import { Route } from '@angular/router'
import { TaxonomyDetailComponent } from '../taxonomy-detail/taxonomy-detail.component'
import { createTaxonomyDefinition } from '../taxonomy-detail/taxonomy.definition'

import { PermissionGuard } from '../../abacus/guards/permission.guard'
import { AuthGuard } from '../../abacus/guards/auth.guard'

import { RiskListComponent } from './risk-list/risk-list.component'

export const riskRoutes: Route[] = [
  {
    path: 'risk-management-stages',
    component: RiskListComponent,
    canActivate: [AuthGuard, PermissionGuard],
    data: {
      permission: 'browseTaxonomies'
    }
  },
  {
    path: 'risk-management-stages/:id/edit',
    redirectTo: 'risk-management-stages/:id',
    pathMatch: 'full'
  },
  {
    path: 'risk-management-stages/:id',
    component: TaxonomyDetailComponent,
    canActivate: [AuthGuard, PermissionGuard],
    data: {
      definition: createTaxonomyDefinition({
        className: 'Risk',
        nameSingular: 'Risk Management Stage',
        namePlural: 'Risk Management Stages',
        path: 'risk-management-stages',
        slug: 'taxonomies/risks',
        title: 'Risk Management Stages'
      }),
      permission: 'readTaxonomies'
    }
  }
]
